import {useTranslation} from 'react-i18next';
import React from 'react';

import {DeniedDevices} from '@pexip/media';
import {Button} from '@pexip/components';

import type {DeviceStatusInfo} from '../types';
import {getUserAgentDetails} from '../utils/userAgentDetails';

const {isWindows} = getUserAgentDetails(navigator.userAgent);

export const useInputSuspendedInfo = (
    audioSuspended: boolean,
    videoSuspended: boolean,
): {
    audio: DeviceStatusInfo | undefined;
    video: DeviceStatusInfo | undefined;
} => {
    const {t} = useTranslation();
    return {
        audio: audioSuspended
            ? {
                  title: t(
                      'media.audio-suspended-title',
                      'Have you muted your microphone using an external source?',
                  ),
                  warning: DeniedDevices.Microphone,
                  message: (
                      <>
                          {t(
                              'media.audio-suspended-description',
                              'Please check if you have muted yourself using a headset or your browser, and unmute your microphone from there first.',
                          )}
                          {isWindows && (
                              <>
                                  <div className="mt-2">
                                      {t(
                                          'media.audio-suspended-computer-settings',
                                          "You can also go to your computer's settings to unmute your microphone.",
                                      )}
                                  </div>
                                  <div className="mt-2">
                                      <Button
                                          href="ms-settings:sound"
                                          size="small"
                                          variant="primary"
                                      >
                                          {t(
                                              'media.open-sound-settings',
                                              'Open Sound Settings',
                                          )}
                                      </Button>
                                  </div>
                              </>
                          )}
                      </>
                  ),
              }
            : undefined,
        video: videoSuspended
            ? {
                  title: t(
                      'media.video-suspended-title',
                      'Have you turned off your camera using an external source?',
                  ),
                  warning: DeniedDevices.Camera,
                  message: t(
                      'media.video-suspended-description',
                      'Please check if you have turned off your camera with your browser. This may happen if you open a new tab that is using your camera.',
                  ),
              }
            : undefined,
    };
};
